/**
 * Format location string
 * @param city City name
 * @param state State name
 * @returns Formatted location string
 */
export function formatLocation(city?: string, state?: string) {
  if (city && state) {
    return `${city}, ${state}`;
  }
  return city || state;
}
